import React from "react";
import {Link} from "react-router-dom";
import {Spinner} from "react-bootstrap";

import "./Button.css";
import Tip from "@components/Tip/Tip";

const VARIANTS = ["ghost", "surface", "soft", "filled"];
const TONES = ["danger", "success"];

// variant: ghost (bare), surface (bordered), soft (tinted in the tone), filled (solid tone, primary when neutral).
// tone: neutral | danger | success. `href` renders an <a>, `to` a router <Link>.
// `loading` swaps the icon for a spinner and disables the button.
export default function IconButton({
    ref,
    icon,
    label,
    variant = "ghost",
    tone = "neutral",
    size = "sm",
    tooltip = false,
    loading = false,
    href,
    to,
    type = "button",
    disabled = false,
    className = "",
    ...rest
}) {
    if (!label && import.meta.env.DEV) {
        console.error("IconButton: `label` is required (used as aria-label).");
    }

    const classes = [
        "ui-icon-btn",
        `ui-icon-btn-${VARIANTS.includes(variant) ? variant : "ghost"}`,
        `ui-icon-btn-${["xs", "md"].includes(size) ? size : "sm"}`,
        TONES.includes(tone) && `ui-icon-btn-${tone}`,
        className,
    ].filter(Boolean).join(" ");

    const isLink = (href != null || to != null) && !disabled && !loading;
    const Tag = isLink ? (to != null ? Link : "a") : "button";
    const tagProps = isLink
        ? (to != null ? {to} : {href})
        : {type, disabled: disabled || loading, "aria-busy": loading || undefined};

    const button = (
        <Tag ref={ref} className={classes} aria-label={label} {...tagProps} {...rest}>
            {loading ? <Spinner animation="border" size="sm" role="status"/> : icon}
        </Tag>
    );

    if (!tooltip) return button;

    return (
        <Tip placement="bottom" text={label}>
            {button}
        </Tip>
    );
}
